import type { OasisManagerVisitItem } from '../../services/api/types.gen';

/**
 * EMR-1864: the OASIS Manager warns before Roger exports, or marks uploaded,
 * an assessment the External EMR charted (`managed_in_external_emr`). Who
 * charts it sends it to iQIES (Daniel, 2026-10-26). Roger warns and never
 * blocks. The row's "E" says only that it was imported (EMR-3239).
 */
export type ExternalEmrOasisAction = 'export' | 'mark';

export function externalEmrOwned(
  visits: readonly OasisManagerVisitItem[]
): OasisManagerVisitItem[] {
  return visits.filter(v => v.managed_in_external_emr === true);
}

export function externalEmrOasisWarning(
  action: ExternalEmrOasisAction,
  count: number
): { title: string; message: string; confirmLabel: string } {
  const owned =
    count === 1 ? '1 selected assessment' : `${count} selected assessments`;
  const them = count === 1 ? 'it' : 'them';
  if (action === 'export') {
    return {
      title: 'Export from Roger?',
      message: `The External EMR charted ${owned}. It sends its own assessments to iQIES. Export ${them} from Roger only if the External EMR has not.`,
      confirmLabel: 'Export anyway',
    };
  }
  return {
    title: 'Mark as uploaded in Roger?',
    message: `The External EMR charted ${owned}. Mark ${them} uploaded only if you know iQIES has ${them}. Roger then stops taking the External EMR's changes to ${them}.`,
    confirmLabel: 'Mark anyway',
  };
}
